import { CART_CONSTANTS } from '../constants/ui';
import { QUERY_PARAMS as ALGOLIA_QUERY_PARAMS } from '../constants/algolia';

import { CartProductType, CartState } from '../types/state/reducers/cartReducersTypes';
import { NextRouter } from 'next/router';

import httpHelpers from './http';

// TODO test
const filterOutDiscountItem = (product: CartProductType): boolean => {
  return product.name !== CART_CONSTANTS.BUNDLE_DISCOUNT_PRODUCT_NAME;
};

// TODO test
const buildCheckoutLink = (router: NextRouter): string => {
  const queryId = router.query[ALGOLIA_QUERY_PARAMS.QUERY_ID];
  const queryParams = {};
  if (queryId) queryParams[ALGOLIA_QUERY_PARAMS.QUERY_ID] = queryId;
  const { mapQueryParams } = httpHelpers;
  return mapQueryParams('/checkout', queryParams);
};

// TODO test
const getTotalProductsCount = (cart: CartState): number => {
  const totalProducts = Object.keys(cart?.order?.items?.products || {}).length || 0;
  const totalBundles = Object.keys(cart?.order?.items?.bundles || {}).length || 0;
  return totalProducts + totalBundles;
};

// TODO test
const bundleAlreadyInCart = (cart: CartState, bundleId: number): boolean => {
  const bundles = Object.values(cart?.order?.items?.bundles || {});
  return !!bundles.find(b => b.id === bundleId);
}

const cartHelpers = {
  filterOutDiscountItem,
  buildCheckoutLink,
  getTotalProductsCount,
  bundleAlreadyInCart,
};

export default cartHelpers;
